import React, { useContext, useEffect, useRef, useState } from 'react';
import {
  Autocomplete,
  Box,
  Button,
  CircularProgress,
  Container,
  Divider,
  FormControl,
  FormControlLabel,
  Grid,
  Paper,
  Radio,
  RadioGroup,
  Stack,
  TextField,
  Typography,
} from '@mui/material';
import { Helmet } from 'react-helmet-async';
import { useNavigate } from 'react-router-dom';

import { GetUsersList, PostFootfall } from '../services/httpServices';
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';
import { AuthContext } from '../Context/Auth/auth.context';

const CreateEnquiry = (props) => {
  const navigate = useNavigate();

  const [userList, setUserList] = useState([]);

  const [clientType, setClientType] = useState('New Client');
  const [vertical, setVertical] = useState('bottom');
  const [horizontal, setHorizontal] = useState('right');
  const [open, setOpen] = useState(false);
  const [saved, setSaved] = useState(false);
  const [loading, setLoading] = useState(true);
  const [message, setMessage] = useState('');
  const [selectedMeetingWith, setSelectedMeetingWith] = useState(null);
  const [selectedSource, setSelectedSource] = useState(null);
  const [selectedFootFallType, setSelectedFootFallType] = useState(null);
  const firstNameRef = useRef('');
  const lastNameRef = useRef('');
  const passportNoRef = useRef('');
  const emailAddressRef = useRef('');
  const addressRef = useRef('');
  const cityRef = useRef('');
  const countryOfOriginRef = useRef('');
  const phoneNumberRef = useRef('');
  const walkinDateRef = useRef('');
  const purposeOfRef = useRef('');
  const meetingWithRef = useRef('');
  const notesRef = useRef('');
  const [isActive, setIsActive] = useState(true);
  let {
    authState: { deptId },
  } = useContext(AuthContext);
  const fetch = async (event) => {
    const users = await GetUsersList();
    setUserList(users);
    setLoading(false);
  };
  useEffect(() => {
    fetch();
  }, []);
  // #endregion Refs

  //   const handleClose = () => {
  //     setOpen(false);
  //   };
  const handleChangeClientType = (event) => {
    setClientType(event.target.value);
  };
  const SaveUser = async (event) => {
    // setPosting(true);
    event.preventDefault();
    //console.log('saveHit');
    const payload = {
      clientType: clientType,
      firstName: firstNameRef.current.value,
      lastName: lastNameRef.current.value,
      passportNo: passportNoRef.current.value,
      address: addressRef.current.value,
      city: cityRef.current.value,
      countryOfOrigin: countryOfOriginRef.current.value,
      phoneNumber: phoneNumberRef.current.value,
      emailAddress: emailAddressRef.current.value,
      walkInDatetime: walkinDateRef.current.value,
      purposeOfVisit: purposeOfRef.current.value,
      meetingWith: meetingWithRef.current.value,
      notes: notesRef.current.value,
      assignedToName: selectedMeetingWith.name,
      assignedToId: selectedMeetingWith.id,
      source: selectedSource.value,
      walkInTime: walkinDateRef.current.value?.split('T')[1],
      //   footfallType: deptId == '6' ? 'Recruitment' : deptId == '7' ? 'Marketing' : deptId == '1' ? 'Sales' : 'Leads',
      footfallType: selectedFootFallType.value,
    };

    //console.log(payload);
    let response = await PostFootfall(payload);
    // console.log('PostResponse:', response);

    if (response.status == 200) {
      setMessage(response.data);
      setSaved(true);
      setOpen(true);
      setTimeout(() => {
        navigate(-1);
      }, 2000);
    } else {
      setMessage(response.data);
      setSaved(false);
      setOpen(true);
      // setPosting(false);
    }
  };
  const handleClose = () => {
    setOpen(false);
  };
  const handleChangeActive = (event) => {
    setIsActive(event.target.value);
  };
  const sources = [{ value: 'Walkin' }, { value: 'Call' }];
  const footfallType = [{ value: 'Recruitment' }, { value: 'Marketing' }, { value: 'Sales' }];
  return (
    <>
      <Helmet>
        <title> Leads | Immigration System </title>
      </Helmet>
      <Container>
        <form onSubmit={SaveUser}>
          <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
            {deptId == '6' ? (
              <Typography variant="h4" gutterBottom>
                Recruitment Enquiries
              </Typography>
            ) : deptId == '7' ? (
              <Typography variant="h4" gutterBottom>
                Marketing Enquiries
              </Typography>
            ) : deptId == '1' ? (
              <Typography variant="h4" gutterBottom>
                Sales Enquiries
              </Typography>
            ) : (
              <Typography variant="h4" gutterBottom>
                Leads
              </Typography>
            )}
            {/* <Button variant="contained" startIcon={<Iconify icon="eva:plus-fill" />}> */}

            <Stack direction="row" divider={<Divider orientation="vertical" flexItem />} spacing={2}>
              <Button
                onClick={() => {
                  navigate(-1);
                }}
                variant="contained"
              >
                Back
              </Button>
              <Button type="submit" variant="contained">
                Create
              </Button>
            </Stack>
          </Stack>
          {loading ? (
            <Grid display="flex" alignItems="center" justifyContent="center" height="40vh" container>
              <CircularProgress size={60} thickness={3} value={100} />
            </Grid>
          ) : (
            <Grid container spacing={3}>
              <Grid item xs={12}>
                <Box component={Paper} p={4}>
                  <Grid container spacing={3}>
                    <Grid item xs={12} sm={4} md={12}>
                      <FormControl>
                        <RadioGroup
                          aria-labelledby="demo-controlled-radio-buttons-group"
                          name="controlled-radio-buttons-group"
                          onChange={handleChangeClientType}
                          value={clientType}
                          row
                        >
                          <FormControlLabel value="New Client" control={<Radio />} label="New Client" />
                          <FormControlLabel value="Existing Client" control={<Radio />} label="Existing Client" />
                        </RadioGroup>
                      </FormControl>
                    </Grid>
                    <Grid item xs={12} sm={4} md={3}>
                      <TextField
                        label="First Name"
                        required
                        variant="outlined"
                        fullWidth
                        size="small"
                        inputRef={firstNameRef}
                      />
                    </Grid>
                    <Grid item xs={12} sm={4} md={3}>
                      <TextField
                        label="Last Name"
                        required
                        variant="outlined"
                        fullWidth
                        size="small"
                        inputRef={lastNameRef}
                      />
                    </Grid>
                    <Grid item xs={12} sm={4} md={3}>
                      <TextField
                        label="Passport No"
                        variant="outlined"
                        fullWidth
                        size="small"
                        inputRef={passportNoRef}
                      />
                    </Grid>
                    <Grid item xs={12} sm={4} md={3}>
                      <TextField
                        label="Email Address"
                        variant="outlined"
                        fullWidth
                        size="small"
                        inputRef={emailAddressRef}
                      />
                    </Grid>
                    <Grid item xs={12} sm={4} md={3}>
                      <TextField label="Address" variant="outlined" fullWidth size="small" inputRef={addressRef} />
                    </Grid>
                    <Grid item xs={12} sm={4} md={3}>
                      <TextField label="City" variant="outlined" fullWidth size="small" inputRef={cityRef} />
                    </Grid>
                    <Grid item xs={12} sm={4} md={3}>
                      <TextField
                        label="Country of Origin"
                        variant="outlined"
                        fullWidth
                        size="small"
                        inputRef={countryOfOriginRef}
                      />
                    </Grid>
                    <Grid item xs={12} sm={4} md={3}>
                      <TextField
                        label="Phone Number"
                        variant="outlined"
                        fullWidth
                        required
                        size="small"
                        inputRef={phoneNumberRef}
                      />
                    </Grid>

                    <Grid item xs={12} sm={4} md={3}>
                      <TextField
                        label="Walkin Datetime"
                        variant="outlined"
                        fullWidth
                        InputLabelProps={{ shrink: true }}
                        type="datetime-local"
                        size="small"
                        inputRef={walkinDateRef}
                      />
                    </Grid>
                    <Grid item xs={12} sm={4} md={3}>
                      <TextField
                        label="Purpose of Visit"
                        variant="outlined"
                        fullWidth
                        size="small"
                        inputRef={purposeOfRef}
                      />
                    </Grid>
                    <Grid item xs={12} sm={4} md={3}>
                      <TextField
                        label="Meeting With"
                        variant="outlined"
                        fullWidth
                        size="small"
                        inputRef={meetingWithRef}
                      />
                    </Grid>
                    <Grid item xs={12} sm={4} md={3}>
                      <Autocomplete
                        id="sources"
                        size="small"
                        options={sources}
                        // defaultValue={userList.find((e) => e.key == user.deptId)}
                        getOptionLabel={(source) => source.value}
                        renderInput={(params) => <TextField required {...params} label="Source" variant="outlined" />}
                        onChange={(event, source) => setSelectedSource(source)}
                      />
                    </Grid>
                    <Grid item xs={12} sm={4} md={3}>
                      <Autocomplete
                        id="footfallType"
                        size="small"
                        options={footfallType}
                        // defaultValue={userList.find((e) => e.key == user.deptId)}
                        getOptionLabel={(source) => source.value}
                        renderInput={(params) => (
                          <TextField required multiline rows={2} {...params} label="Enquiry Type" variant="outlined" />
                        )}
                        onChange={(event, source) => setSelectedFootFallType(source)}
                      />
                    </Grid>

                    <Grid item xs={12} sm={4} md={6}>
                      <TextField
                        label="Notes"
                        variant="outlined"
                        fullWidth
                        size="small"
                        // defaultValue={footFall.notes}
                        inputRef={notesRef}
                        multiline
                        rows={2}
                      />
                    </Grid>
                    <Grid item xs={12} sm={4} md={3}>
                      <Autocomplete
                        id="users"
                        size="small"
                        options={userList}
                        // defaultValue={userList.find((e) => e.key == user.deptId)}
                        getOptionLabel={(user) => user.name}
                        renderInput={(params) => (
                          <TextField required {...params} multiline rows={2} label="Assigned To" variant="outlined" />
                        )}
                        onChange={(event, user) => setSelectedMeetingWith(user)}
                      />
                    </Grid>
                  </Grid>
                </Box>
              </Grid>
            </Grid>
          )}
        </form>
        {saved ? (
          <Snackbar
            anchorOrigin={{ vertical, horizontal }}
            key={vertical + horizontal}
            open={open}
            autoHideDuration={4000}
            onClose={handleClose}
          >
            <Alert elevation={6} variant="filled" onClose={handleClose} severity="success">
              {message}
            </Alert>
          </Snackbar>
        ) : (
          <Snackbar
            key={vertical + horizontal}
            anchorOrigin={{ vertical, horizontal }}
            open={open}
            autoHideDuration={4000}
            onClose={handleClose}
          >
            <Alert elevation={6} variant="filled" onClose={handleClose} severity="error">
              {message}
            </Alert>
          </Snackbar>
        )}
      </Container>
    </>
  );
};

export default CreateEnquiry;
